import React, { useState, useEffect } from "react";
import {Card, Container,Col,Row,Button,Table,FormText} from "react-bootstrap";
import { Input } from "reactstrap";
import Loader from "react-loader-spinner";
import {uploadCustomerInfo, createVerificationLink} from "../services/customerService";
import { set } from "date-fns";


function FullyVerified() {
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(false);
    const [customerLink, setCustomerLink] = useState(null);

    const initData =()=> {
      setPhoneNumber(null)

    }

    const _createVerificationLink= async (value) => {
        if(phoneNumber == null || phoneNumber == ''){
            alert('Veuillez vous assurer d\'entrer le numéro de telephone')
            return;
            }
        setLoading(true)
        var res = await createVerificationLink(value);
        if(res){
            setCustomerLink(res.customer_url)
        }
        initData();
        setLoading(false)
    }

  if(loading){ return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }
  else  {
  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card className="card-plain table-plain-bg">
            <Card.Header>
              <Row style={{ alignItems: "flex-end" }}>
                <Col md="4">
                  <label htmlFor="name">numéro de telephone</label>
                  <Input
                    onChange={(e) => {
                      setPhoneNumber(e.target.value);
                    }}
                  />
                </Col>
                <Col md="4">
                  <Button
                    onClick={() => {
                        _createVerificationLink(phoneNumber);
                    }}
                    variant="success"
                  >
                    Créer une appel de verification
                  </Button>
                </Col>
              </Row>
              <Row style={{ alignItems: "flex-end" , marginTop:30}}>
              <Col md="12">
                  <label  htmlFor="name">URL du client</label>
                  <p style={{color : 'green'}}>{customerLink}</p>     
              </Col>
              </Row>
              <Row style={{ alignItems: "flex-end" , marginTop:20}}>
              <Col md="12">
                  <label  htmlFor="name">URL d'agent</label>
                  <p style={{color : 'green'}}>{"https://app.fully-verified.com/ops/main_ops_verify"}</p>     
              </Col>
              </Row>
            </Card.Header>
          </Card>
        </Col>
      </Row>
    </Container>
  );
                }
}

export default FullyVerified;
